/* eslint-disable react-refresh/only-export-components */
import { createContext, useContext, useEffect, useMemo, useState, type ReactNode } from "react";
import { api } from "../api/client";
import type { KiraSettings } from "../api/types";

interface AppSettingsContextValue {
  settings: KiraSettings | null;
  environmentLabel: string;
  loading: boolean;
}

const AppSettingsContext = createContext<AppSettingsContextValue>({
  settings: null,
  environmentLabel: "sf-devs",
  loading: true,
});

export function AppSettingsProvider({ children }: { children: ReactNode }) {
  const [settings, setSettings] = useState<KiraSettings | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let active = true;
    api
      .getSettings()
      .then((cfg) => {
        if (active) setSettings(cfg);
      })
      .catch(() => {
        if (active) setSettings(null);
      })
      .finally(() => {
        if (active) setLoading(false);
      });
    return () => {
      active = false;
    };
  }, []);

  const value = useMemo(
    () => ({
      settings,
      environmentLabel: "sf-devs",
      loading,
    }),
    [settings, loading],
  );

  return (
    <AppSettingsContext.Provider value={value}>{children}</AppSettingsContext.Provider>
  );
}

export function useAppSettings() {
  return useContext(AppSettingsContext);
}
